import React from "react";
// import { matchPath } from "react-router";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ReactRouterPropTypes from "react-router-prop-types";

// import axios from "axios";
// import validator from "validator";
// import moment from "moment";

import AppContext from "./AppContext";
// import { base, firebaseApp } from "../base";

import { alertTypes } from "../vars";

// import Raven from "raven-js";

// axios.defaults.withCredentials = true;

class AppProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.setInitalState();
    }

    setInitalState = () => {
        return {
            loader: { self: true, loaded: false },
            authenticated: null,
            user: {
                id: "",
                name: "",
                first_name: "",
                real_name: "",
                email: "",
                avatar: "",
                token: ""
            },
            dataDeleted: false,
            userChannels: [],
            channel: { id: "", name: "" },
            team: { members: [], id: null, name: "" },
            questions: {
                feeling_good: {
                    value: "1 thing I’m feeling good about",
                    ref: React.createRef(),
                    error: null,
                    suggestions: this.suggestionsInit()
                },
                improve: {
                    value: "1 thing I want to improve",
                    ref: React.createRef(),
                    error: null,
                    suggestions: this.suggestionsInit()
                },
                appreciate: {
                    value: "1 thing a teammate did that I really appreciated",
                    ref: React.createRef(),
                    error: null,
                    suggestions: this.suggestionsInit()
                }
            },
            alert: {
                type: null,
                show: false,
                message: null,
                ref: React.createRef()
            },
            error: {
                title: null,
                message: null
            },
            answers: {},
            timestamps: { created: null, modified: null },
            yay: false
        };
    };

    componentDidMount() {
        // const path = this.props.location.pathname;
        /*
        const redirect =
            path !== "/" &&
            path !== "/how" &&
            path !== "/terms-conditions" &&
            path !== "/privacy-policy";

        const match = matchPath(this.props.history.location.pathname, {
            path: "/things/:channel"
        });
        */
        /*
        axios
            .get(process.env.REACT_APP_API_URL + "/auth")
            .then(value => {
                const newState = { ...this.state };
                const data = value.data;
                if (data.authenticated && data.token) {
                    newState.authenticated = true;
                    newState.user.name = data.user.profile.display_name;
                    newState.user.real_name = data.user.profile.real_name;
                    newState.user.id = data.user.id;
                    newState.team.id = data.user.team_id;

                    const splitName = data.user.profile.real_name.split(" ");
                    newState.user.first_name =
                        splitName.length > 0
                            ? splitName[0]
                            : data.user.profile.real_name;
                    newState.user.token = data.token;
                    firebaseApp
                        .auth()
                        .signInWithCustomToken(data.firebase_token)
                        .catch(error => {
                            error.name = "Firebase Error";
                            Raven.captureException(error);

                            newState.error.title = "Oops";
                            newState.error.message =
                                "Something is wrong, please try again later";
                        });
                } else {
                    newState.authenticated = false;
                }

                this.setState(newState);

                if (newState.authenticated && redirect) {
                    this.checkChannelUrlMatch(match);
                }

                this.getTeamMembers();
                this.getTeamName();
                this.getUserChannels();

                setTimeout(() => {
                    this.setState({ loader: { self: false } });

                    setTimeout(() => {
                        this.setState({ loader: { loaded: true } });
                    }, 500);
                }, 1500);
            })
            .catch(e => {
                this.setState({
                    authenticated: false,
                    error: {
                        title: "Not Logged In",
                        message: "Please signin with your Slack account"
                    }
                });
            });
        */
        // }
    }

    componentWillUnmount() {
        if (this.ref) {
            // base.removeBinding(this.ref);
        }
    }

    checkChannelUrlMatch = match => {
        /*
        const { team, user } = this.state;
        let channelId;

        // If there is a channel in the URL, lookit up!
        if (match !== null) {
            const channelName = match.params.channel;

            // Reverse lookup ID
            base.ref(`${team.id}/channel_names/${channelName}`)
                .once("value")
                .then(data => {
                    channelId = data.val();

                    // Lookup if user belongs to channel
                    if (channelId) {
                        return base
                            .ref(
                                `${team.id}/users/${
                                    user.id
                                }/channels/${channelId}`
                            )
                            .once("value");
                    } else {
                        this.setState({
                            error: {
                                title: "Channel Not Found!",
                                message:
                                    "This channel doesn't exist, or has been renamed. Please try again!"
                            }
                        });
                        const e = new Error(this.state.error.message);
                        e.name = this.state.error.title;

                        throw e;
                    }
                })
                .then(channelCheck => {
                    const belongsToChannel = channelCheck.val();

                    if (belongsToChannel === true) {
                        this.setState({
                            channel: {
                                id: channelId,
                                name: channelName
                            }
                        });
                        this.getChannelAnswers(this.state.channel.id);
                    } else {
                        this.setState({
                            error: {
                                title: "No Channels Found!",
                                message:
                                    "It looks like you don't belong to any 3things channels. Why not start one for your team in Slack with /3things-start?"
                            }
                        });

                        const e = new Error(this.state.error.message);
                        e.name = this.state.error.title;

                        throw e;
                    }
                })
                .catch(err => {
                    Raven.captureException(err);

                    switch (err.name) {
                        case "No Channels Found!":
                        case "Channels Not Found!":
                            break;
                        default:
                            err.name = "Oops";
                            err.message =
                                "Something is wrong, please try again later";
                    }

                    this.setState({
                        error: {
                            title: err.name,
                            message: err.message
                        }
                    });
                });
        } else {
            // Otherwise check the user's channels and bring back the 1st one
            let channelIds;

            base.ref(`${team.id}/users/${user.id}/channels`)
                .once("value")
                .then(data => {
                    channelIds = data.val();

                    if (channelIds && Object.keys(channelIds).length > 0) {
                        channelId = channelIds[Object.keys(channelIds)[0]];

                        if (channelId) {
                            return base
                                .ref(`${team.id}/channel_names`)
                                .once("value");
                        } else {
                            const e = new Error(
                                "Channel ID is not Valid for Workspace!"
                            );
                            throw e;
                        }
                    } else {
                        this.setState({
                            error: {
                                title: "No Channels Found!",
                                message:
                                    "It looks like you don't belong to any 3things channels. Why not start one for your team in Slack with /3things-start?"
                            }
                        });

                        const e = new Error(this.state.error.message);
                        e.name = this.state.error.title;
                        throw e;
                    }
                })
                .then(channelNames => {
                    if (channelNames) {
                        const channelNameValues = channelNames.val();

                        Object.keys(channelNameValues).forEach((key, index) => {
                            if (
                                channelNameValues[key] ===
                                Object.keys(channelIds)[0]
                            ) {
                                this.setState({
                                    channel: {
                                        id: channelNameValues[key],
                                        name: key
                                    }
                                });
                                if (this.state.channel.name) {
                                    this.props.history.push(
                                        `/things/${this.state.channel.name}`
                                    );
                                }
                            }
                        });

                        if (this.state.channel.id === "") {
                            this.setState({
                                error: {
                                    title: "No Channels Found!",
                                    message:
                                        "It looks like you don't belong to any 3things channels. Why not start one for your team in Slack with /3things-start?"
                                }
                            });

                            const e = new Error(this.state.error.message);
                            e.name = this.state.error.title;

                            throw e;
                        } else {
                            this.getChannelAnswers(this.state.channel.id);
                        }
                    } else {
                        this.setState({
                            error: {
                                title: "No Channels Found!",
                                message:
                                    "It looks like you don't belong to any 3things channels. Why not start one for your team in Slack with /3things-start?"
                            }
                        });

                        const e = new Error(this.state.error.message);
                        e.name = this.state.error.title;

                        throw e;
                    }
                })
                .catch(err => {
                    Raven.captureException(err);

                    switch (err.name) {
                        case "No Channels Found!":
                        case "Channels Not Found!":
                            break;
                        default:
                            err.name = "Oops";
                            err.message =
                                "Something is wrong, please try again later";
                    }

                    this.setState({
                        error: {
                            title: err.name,
                            message: err.message
                        }
                    });
                });
        }
        */
    };

    checkIfFieldError = name => {
        const { questions } = this.state;

        if (questions[name].error) {
            questions[name].error = null;
            this.setState({
                questions
            });

            this.checkIfPageError();
        }
    };

    checkIfPageError = () => {
        const { error, questions } = this.state;
        const errors = [];

        if (error) {
            // check if any questions still have an error
            Object.keys(questions).forEach(key => {
                if (questions[key].error) {
                    errors.push(key);
                }
            });
        }

        if (errors.length === 0) {
            const newAlert = { ...this.state.alert };
            newAlert.show = false;
            newAlert.type = null;
            newAlert.message = null;

            this.setState({
                alert: newAlert
            });
        }
    };

    closeMessage = event => {
        event.preventDefault();
        const newAlert = { ...this.state.alert };
        newAlert.show = false;
        this.setState({
            alert: newAlert
        });
    };

    deleteUserData = event => {
        /*
        const button = event.target;

        // First go to the answer_user node in the DB
        // for each channel, loop through year, weeks to get the answer keys
        // For each answer key delete from the answers node
        // Finally, delete the user's profile
        const { team, user } = this.state;

        base.ref(`${team.id}/answer_user/${user.id}`)
            .once("value")
            .then(data => {
                const answerData = data.val();
                const answerKeys = [];
                const deletePromises = [];

                if (answerData) {
                    const channelIds = Object.keys(answerData);

                    channelIds.forEach(channelId => {
                        const channelData = answerData[channelId];
                        const years = Object.keys(channelData);

                        years.forEach(year => {
                            const yearData = channelData[year];
                            const weeks = Object.keys(yearData);

                            weeks.forEach(week => {
                                const answerKey = yearData[week]["answers"];
                                answerKeys.push(answerKey);
                            });
                        });
                    });
                }

                if (answerKeys.length > 0) {
                    const answerRef = base.ref(`${team.id}/answers/`);

                    answerKeys.forEach(answerKey => {
                        const remove = answerRef.child(answerKey).remove();

                        deletePromises.push(remove);
                    });
                }

                Promise.all(deletePromises).then(data => {
                    base.ref(`${team.id}/users/`)
                        .child(user.id)
                        .remove()
                        .then(() => {
                            return base
                                .ref(`${team.id}/answer_user/`)
                                .child(user.id)
                                .remove();
                        })
                        .then(() => {
                            const newError = { ...this.state.error };
                            const newAlert = { ...this.state.alert };
                            const newChannel = { ...this.state.channel };

                            newAlert.show = true;
                            newAlert.type = alertTypes.SUCCESS;
                            newAlert.message =
                                "Your data has been removed. We're sad to see you go 😢";
                            newError.title = "Your data is gone.";
                            newError.message =
                                "Please logout to leave the application.";
                            newChannel.id = null;
                            newChannel.name = null;

                            button.blur();

                            this.setState({
                                error: newError,
                                alert: newAlert,
                                dataDeleted: true,
                                channel: newChannel,
                                yay: false
                            });

                            const ref = this.state.alert.ref;
                            ref.current.focus();
                        });
                });
            })
            .catch(err => {
                console.log(err);
            });
            */
    };

    editResponses = event => {
        event.preventDefault();
        const { channel } = this.state;

        this.props.history.push(`/things/${channel.name}`);
        window.scrollTo(0, 0);
    };

    focusOnFirstError = errors => {
        const ref = this.state.questions[errors[0]].ref;
        ref.current.element.focus();
    };

    getChannelAnswers = channelId => {
        /*
        const week = moment().format("W");
        const year = moment().format("Y");
        const state = this.state;

        this.ref = base
            .ref(
                `${state.team.id}/answer_channel/${channelId}/${year}/${week}/${
                    state.user.id
                }`
            )
            .once("value")
            .then(snapshot => {
                const answersKey = snapshot.val();
                if (answersKey) {
                    this.setState({
                        answersKey
                    });
                }
                return base
                    .ref(`${state.team.id}/answers/${answersKey}`)
                    .once("value");
            })
            .then(snapshot => {
                const data = snapshot.val();
                if (data) {
                    if (data.answers) {
                        this.setState({
                            answers: data.answers
                        });
                    }

                    if (data.ts) {
                        this.setState({
                            timestampes: data.ts
                        });
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: {
                        title: "Oops",
                        message: "Something is wrong, please try again later"
                    }
                });
                Raven.captureException(err);
            });
            */
    };

    getChannelMembers = (channelId, isPrivate) => {
        /*
        const { team, user } = this.state;
        const requestType = isPrivate ? "group" : "channel";

        axios
            .get(
                `https://slack.com/api/${requestType}s.infox?token=${
                    user.token
                }&channel=${channelId}`,
                { withCredentials: false }
            )
            .then(value => {
                if (
                    value.data[`${requestType}`] &&
                    value.data[`${requestType}`].members
                ) {
                    const members = value.data[`${requestType}`].members;
                    const channelTeam = [];
                    const newState = { ...this.state };
                    newState.channel.members = members;

                    members.forEach(member => {
                        if (member !== this.state.user.id) {
                            const match = newState.team.members.find(
                                user => user.id === member
                            );

                            if (match && match !== "undefined") {
                                channelTeam.push(match);
                            }
                        }
                    });

                    newState.team.members = channelTeam;

                    this.setState(newState);
                }
            })
            .catch(err => {
                team.members = [];
                this.setState({
                    error: {
                        title: "Oops",
                        message: "Something is wrong, please try again later"
                    }
                });
                err.name = "Slack API Error";
                Raven.captureException(err);
                this.setState({ team: team });
            });
            */
    };

    getTeamMembers = () => {
        /*
        const { team, user } = this.state;

        axios
            .get(`https://slack.com/api/users.list?token=${user.token}`, {
                withCredentials: false
            })
            .then(value => {
                if (value.data.members) {
                    const members = value.data.members;

                    const filtered = members.filter(member => {
                        return (
                            !member.is_bot &&
                            !member.deleted &&
                            !member.is_restricted &&
                            member.name !== "slackbot"
                        );
                    });
                    team.members = filtered;

                    this.setState({ team: team });
                } else {
                    const e = new Error(value.data.error);
                    e.name = "Slack API Error";
                    throw e;
                }
            })
            .catch(err => {
                team.members = [];
                this.setState({
                    team: team,
                    error: {
                        title: "Oops",
                        message: "Something is wrong, please try again later"
                    }
                });

                Raven.captureException(err);
            });
            */
    };

    getTeamName = () => {
        /*
        const { team, user } = this.state;

        axios
            .get(`https://slack.com/api/team.info?token=${user.token}`, {
                withCredentials: false
            })
            .then(value => {
                if (value.data.team) {
                    team.name = value.data.team.name;
                    this.setState({ team: team });
                } else {
                    const e = new Error(value.data.error);
                    e.name = "Slack API Error";
                    throw e;
                }
            })
            .catch(err => {
                team.name = "";

                this.setState({
                    team: team,
                    error: {
                        title: "Oops",
                        message: "Something is wrong, please try again later"
                    }
                });

                Raven.captureException(err);
            });
        */
    };

    getUserChannels = () => {
        /*
        const teamId = this.state.team.id;
        const userId = this.state.user.id;
        let channelNames;

        base.ref(`${teamId}/channel_names`)
            .once("value")
            .then(data => {
                channelNames = data.val();
                return base
                    .ref(`${teamId}/users/${userId}/channels`)
                    .once("value");
            })
            .then(data => {
                if (data) {
                    const channels = data.val();

                    if (channels) {
                        Object.keys(channels).forEach(item => {
                            if (channels[item]) {
                                const channelName = Object.keys(
                                    channelNames
                                ).find(name => {
                                    return channelNames[name] === item;
                                });
                                channels[item] = channelName;
                            }
                        });

                        this.setState({
                            userChannels: channels
                        });
                    }
                } else {
                    throw new Error("no channel");
                }
            })
            .catch(err => {
                console.log(err);
            });
        */
    };

    writeAnswers = (year, week, answersKey) => {
        const { team, channel, user } = this.state;
        const writes = {};
        writes[
            `${team.id}/answer_channel/${channel.id}/${year}/${week}/${user.id}`
        ] = answersKey;
        writes[
            `${team.id}/answer_user/${user.id}/${
                channel.id
            }/${year}/${week}/answers`
        ] = answersKey;

        return writes;
    };

    handleSubmit = event => {
        /*
        event.preventDefault();

        const { questions, team, timestamps } = this.state;
        let { answersKey } = this.state;
        const errors = [];
        const answers = {};

        Object.keys(questions).forEach((key, index) => {
            const question = questions[key];
            const value = question.ref.current.element.value.trim();
            question.error = validator.isEmpty(value);
            answers[key] = value;

            if (question.error) {
                errors.push(key);
            }
        });

        if (errors.length >= 1) {
            this.focusOnFirstError(errors);

            const newAlert = { ...this.state.alert };
            newAlert.show = true;
            newAlert.type = alertTypes.ERROR;
            newAlert.message = "Please fill out all fields";

            this.setState({
                alert: newAlert
            });
        } else {
            if (timestamps.created === null) {
                timestamps.created = moment().unix();
            }

            timestamps.modified = moment().unix();
            const week = moment().format("W");
            const year = moment().format("Y");

            if (answersKey) {
                base.ref(`${team.id}/answers/${answersKey}`)
                    .set({ answers, ts: timestamps })
                    .then(() => {
                        const writes = this.writeAnswers(
                            year,
                            week,
                            answersKey
                        );
                        return base.ref().update(writes);
                    })
                    .then(() => {
                        const newState = {
                            answers: answers,
                            timestamps,
                            yay: true
                        };
                        this.sendToConfirmationScreen(newState);
                        this.props.history.push("/yay");
                    })
                    .catch(err => {
                        this.setState({
                            error: {
                                title: "Oops",
                                message:
                                    "Something is wrong, please try again later"
                            }
                        });
                        err.name = "Firebase Error";
                        Raven.captureException(err);
                    });
            } else {
                base.ref(`${team.id}/answers`)
                    .push({ answers, ts: timestamps })
                    .then(value => {
                        answersKey = value.key;
                        const writes = this.writeAnswers(
                            year,
                            week,
                            answersKey
                        );
                        return base.ref().update(writes);
                    })
                    .then(() => {
                        const newState = {
                            answersKey,
                            answers: answers,
                            timestamps,
                            yay: true
                        };
                        this.sendToConfirmationScreen(newState);
                        this.props.history.push("/yay");
                    })
                    .catch(err => {
                        this.setState({
                            error: {
                                title: "Oops",
                                message:
                                    "Something is wrong, please try again later"
                            }
                        });
                        err.name = "Firebase Error";
                        Raven.captureException(err);
                    });
            }
        }
        */
    };

    sendToConfirmationScreen(newState) {
        this.setState(newState);
        this.props.history.push("/yay");
        window.scrollTo(0, 0);
    }

    hideMessage = event => {
        const { answers, questions } = this.state;

        for (let x = 0; x < questions.length; x++) {
            if (questions[x].name in answers) {
                if (
                    answers[questions[x].name].length === 0 &&
                    event.target === questions[x].ref.current
                ) {
                    questions[x].error = false;
                }
            }
        }

        const error = !Object.keys(questions).every(index => {
            return questions[index].error === false;
        });

        const newAlert = { ...this.state.alert };
        newAlert.show = error;
        newAlert.type = error ? alertTypes.ERROR : alertTypes.SUCCESS;

        this.setState({
            alert: newAlert,
            questions: questions
        });
    };

    suggestionsInit = () => {
        return {
            show: false,
            top: null,
            left: null,
            currentText: "",
            currentSelection: 0,
            members: [],
            startPosition: null
        };
    };

    setSuggestion = (event, question) => {
        const { target } = event;
        const {
            members,
            currentSelection,
            startPosition
        } = this.state.questions[question].suggestions;
        const selection = members[currentSelection].profile.display_name;
        const currentAnswer = this.state.answers.answers[question];
        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;

        const newText = `${currentAnswer.slice(
            0,
            startPosition - 1
        )}@${selection}${currentAnswer.slice(
            startPosition + selection.length,
            currentAnswer.length
        )}`;

        target.value = newText;

        newQuestion.suggestions = this.suggestionsReset(newSuggestions);

        this.setState({
            questions: newQuestions
        });

        this.state.questions[question].ref.current.resetState();
    };

    suggestionsKeyDown = (question, event) => {
        const { which } = event;
        const { members, currentSelection, show } = this.state.questions[
            question
        ].suggestions;
        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;

        // the down arrow
        if (which === 40 && show) {
            event.preventDefault();

            newSuggestions.currentSelection =
                Math.abs(currentSelection + 1) % members.length;

            this.setState({
                questions: newQuestions
            });
        }

        // the up arrow
        if (which === 38 && show) {
            event.preventDefault();

            newSuggestions.currentSelection =
                currentSelection - 1 > -1
                    ? currentSelection - 1
                    : members.length - 1;

            this.setState({
                questions: newQuestions
            });
        }

        // ENTER
        if (which === 13 && show) {
            event.preventDefault();

            this.setSuggestion(event, question);
        }

        // TAB
        if (which === 9 && show) {
            event.preventDefault();

            if (newSuggestions.members.length === 1) {
                this.setSuggestion(event, question);
            } else if (!event.shiftKey) {
                newSuggestions.currentSelection =
                    Math.abs(currentSelection + 1) % members.length;
            } else {
                const newSelection =
                    currentSelection - 1 > -1
                        ? currentSelection - 1
                        : members.length - 1;
                newSuggestions.currentSelection = newSelection;
            }

            this.setState({
                questions: newQuestions
            });
        }

        // Spacebar or ESC key
        if ((which === 32 || which === 27) && show) {
            newQuestion.suggestions = this.suggestionsReset(newSuggestions);

            this.setState({
                questions: newQuestions
            });

            this.state.questions[question].ref.current.resetState();
        }
    };

    suggestionsMembers = (question, data) => {
        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;
        const { currentSelection } = newSuggestions;

        newSuggestions.currentText = data.text.toLowerCase();
        newSuggestions.members = this.state.team.members.filter(user => {
            return (
                user.profile.display_name
                    .toLowerCase()
                    .indexOf(newSuggestions.currentText.toLowerCase()) !== -1 ||
                user.profile.real_name
                    .toLowerCase()
                    .indexOf(newSuggestions.currentText.toLowerCase()) !== -1
            );
        });

        if (!newSuggestions.members[currentSelection]) {
            newSuggestions.currentSelection = 0;
        }

        this.setState({
            questions: newQuestions
        });
    };

    suggestionsMouse = (event, question) => {
        const { target } = event;
        const items = [...target.parentNode.childNodes];
        const index = items.indexOf(target);
        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;
        newSuggestions.currentSelection = index;

        this.setState({
            questions: newQuestions
        });
    };

    suggestionsReset = newSuggestions => {
        newSuggestions.show = false;
        newSuggestions.top = null;
        newSuggestions.left = null;
        newSuggestions.currentText = "";
        newSuggestions.currentSelection = 0;
        newSuggestions.members = [];
        newSuggestions.startPosition = null;

        return newSuggestions;
    };

    suggestionsSelect = (event, question) => {
        const target = this.state.questions[question].ref.current.element;
        const {
            members,
            currentSelection,
            startPosition
        } = this.state.questions[question].suggestions;
        const selection = members[currentSelection].profile.display_name;
        const currentAnswer = this.state.answers.answers[question];

        const newText = `${currentAnswer.slice(
            0,
            startPosition - 1
        )}@${selection}${currentAnswer.slice(
            startPosition + selection.length,
            currentAnswer.length
        )}`;

        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;

        target.value = newText;

        newQuestion.suggestions = this.suggestionsReset(newSuggestions);

        this.setState({
            questions: newQuestions
        });

        this.state.questions[question].ref.current.resetState();

        target.focus();
    };

    suggestionsToggle = (question, data) => {
        const { hookType, cursor } = data;
        const newQuestions = { ...this.state.questions };
        const newQuestion = newQuestions[question];
        const newSuggestions = newQuestion.suggestions;
        newQuestion.suggestions = this.suggestionsReset(newSuggestions);

        if (hookType === "start") {
            newSuggestions.show = true;
            newSuggestions.left = cursor.left;
            newSuggestions.top = cursor.top + cursor.height;
            newSuggestions.startPosition = cursor.selectionStart;

            this.setState({
                questions: newQuestions
            });
        }

        if (hookType === "cancel") {
            this.setState({
                suggestions: newSuggestions
            });
        }
    };

    textareaOnChange = event => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.checkIfFieldError(name);

        this.setState({
            answers: {
                answers: {
                    [name]: value
                }
            }
        });
    };

    render() {
        const { loader } = this.state;

        return (
            <AppContext.Provider
                value={{
                    state: this.state,
                    // message: message,
                    fadeOut: !loader.self,
                    hideMessage: this.hideMessage,
                    closeMessage: this.closeMessage,
                    handleSubmit: this.handleSubmit,
                    deleteUserData: this.deleteUserData,
                    editResponses: this.editResponses,
                    suggestionsKeyDown: this.suggestionsKeyDown,
                    suggestionsMembers: this.suggestionsMembers,
                    suggestionsMouse: this.suggestionsMouse,
                    suggestionsSelect: this.suggestionsSelect,
                    suggestionsToggle: this.suggestionsToggle,
                    textareaOnChange: this.textareaOnChange
                }}
            >
                {this.props.children}
            </AppContext.Provider>
        );
    }
}

AppProvider.propTypes = {
    children: PropTypes.node,
    history: ReactRouterPropTypes.history.isRequired,
    location: ReactRouterPropTypes.location.isRequired
};

export default withRouter(AppProvider);



// WEBPACK FOOTER //
// ./src/components/AppProvider.jsx